import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//- Get All
export const GetAll = createAsyncThunk(
  "termsofservices/termsofservice/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.TermsOfServices.TermsOfService}?name=${filter?.name || ""}
        &description=${filter?.description || ""}
        &page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// - Get Single
export const GetSingle = createAsyncThunk(
  "termsofservices/termsofservice/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.TermsOfServices.TermsOfService}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Create
export const Create = createAsyncThunk(
  "termsofservices/termsofservice/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.TermsOfServices.TermsOfService, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//update
export const Update = createAsyncThunk(
  "termsofservices/termsofservice/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.TermsOfServices.TermsOfService}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Delete
export const Delete = createAsyncThunk(
  "termsofservices/termsofservice/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.TermsOfServices.TermsOfService}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Status
export const StatusTermsOfService = createAsyncThunk(
  "termsofservices/termsofservice/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.TermsOfServices.TermsOfService}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "termsofservice",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      //GET ALL
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // GET SINGLE
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // CREATE
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload?.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //UPDATE
      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (termsofservice) => termsofservice.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //DELETE
      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (termsofservice) => termsofservice.id !== action.payload,
        );
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // STATUS
      .addCase(StatusTermsOfService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusTermsOfService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (termsofservice) => termsofservice.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(StatusTermsOfService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
